import React from "react";
import { PromptResult } from "./businessReportOutcomeContent";
import {
  BusinessReportOutcomeDetails,
  BusinessReportOutcomeEvidence,
  BusinessReportOutcomeEvidenceResult,
} from "@/modules/snapshots/businessReports.types";
import { EvidenceWithContext } from "./types";
import { useCurrentPdf } from "@/views/chat/hooks/useCurrentPdf";
import { Highlight } from "@/types/evidences";

interface Props {
  businessReportOutcome: BusinessReportOutcomeDetails | null;
  inProgress: boolean;
  setPromptsResult: (prompts: PromptResult[]) => void;
}

export const BusinessReportOutcomeInit: React.FC<Props> = ({
  businessReportOutcome,
  inProgress: inProgress,
  setPromptsResult,
}) => {
  const { setCurrentPdfId } = useCurrentPdf();

  React.useEffect(() => {
    if (businessReportOutcome) {
      const evidences = businessReportOutcome.evidences.reduce(
        (acc: EvidenceWithContext[], evidence: BusinessReportOutcomeEvidence) => [
          ...acc,
          ...evidence.result.map((row: BusinessReportOutcomeEvidenceResult) => ({
            highlights: row.highlights ? (JSON.parse(row.highlights) as Highlight[]) : [],
            citationId: row.citation_id,
            documentId: row.document_id,
            fseId: row.fse_id,
            business_report_prompt_id: evidence.business_report_prompt_id,
            id: `evidence-${row.citation_id}`,
            answerOffsetEnd: 0,
            answerOffsetStart: 0,
          })),
        ],
        [],
      );

      setPromptsResult(
        [...businessReportOutcome.result]
          .sort((a, b) => a.order - b.order)
          .map((prompt, index) => ({
            prompt: prompt.prompt,
            name: prompt.name,
            order: prompt.order,
            business_report_prompt_id: prompt.business_report_prompt_id,
            processing: inProgress ? index == 0 : false,
            show: inProgress ? index == 0 : true,
            business_report_outcome_result_id: prompt.id,
            evidences: evidences.filter(
              evidence => evidence.business_report_prompt_id === prompt.business_report_prompt_id,
            ),
            content: businessReportOutcome.result
              .filter(row => row.id === prompt.id)
              .map(row => row.result)
              .join(""),
          })),
      );

      if (businessReportOutcome.fs_entry) {
        setCurrentPdfId(businessReportOutcome.fs_entry.id);
      }
    }
  }, [setCurrentPdfId, businessReportOutcome, inProgress, setPromptsResult]);

  return null;
};
